import React from 'react';
import PropTypes from 'prop-types';
import { Modal as BootstrapModal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function Modal({ children, className, icon, show, title, onHide }) {
  return (
    <BootstrapModal className={`ds-modal ${className}`} show={show} onHide={onHide}>
      <BootstrapModal.Body className="modal-padding overflow-auto">
        <div className="text-center">
          <FontAwesomeIcon className="icon-gradient" icon={icon} size="2x"/>
        </div>
        <h3 className="text-center my-4 py-3"><strong>{title}</strong></h3>
        {children}
      </BootstrapModal.Body>
    </BootstrapModal>
  );
}

export function Footer({ children, footerOrientation }) {
  const footerOrientationClass = () => {
    switch (footerOrientation) {
    case 'center':
      return 'text-center';
    case 'left':
      return 'text-left';
    case 'right':
      return 'text-right';
    }
  };

  return (
    <div className={`${footerOrientationClass()} mt-5`}>
      {children}
    </div>
  );
}

Footer.propTypes = {
  children: PropTypes.node,
  closeButtonText: PropTypes.string,
  footerOrientation: PropTypes.oneOf(['left', 'right', 'center']),
  onHide: PropTypes.func
};

Modal.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  icon: PropTypes.object,
  show: PropTypes.bool,
  title: PropTypes.string,
  onHide: PropTypes.func
};

Modal.Footer = Footer;
export default Modal;
